import closest from 'closest';
import Event from 'data/event';
import MultiAddInputComponent from 'form-fields/multi-add-input';
import DateTimePicker from 'form-fields/datetime-picker';
import FlipSwitch from 'foundations/flip-switch';
import Notification from 'foundations/notification'


;(function() {
    function initEventSwitcher() {
        var select2El = $('._base-sidebar-and-content .event-switcher').select2();

        if (select2El.length) {
            var select2ArrowEl = document.querySelector(
                '._base-sidebar-and-content .event-switcher-and-create-event-button ' +
                '.select2 .selection .select2-selection .select2-selection__arrow'
            );
            select2ArrowEl.innerHTML = select2ArrowEl.innerHTML + '<span class="plus">+</span>';

            select2El.on('change', function() {
                switch (select2El.val()) {
                    case 'new':
                        window.location = '/dashboard/create-event/';
                        break;

                    case 'archive':
                        window.location = '/dashboard/events-overview/';
                        break;

                    default:
                        window.location = '/dashboard/event/' + select2El.val() + '/';
                        break;
                }
            });
        }
    }

    function toggleExpanded(element, parentElement) {
        if (element === parentElement) {
            element.classList.toggle('expanded');
        } else {
            element.classList.remove('expanded');
        }
    }

    function initPopOverToggler(baseClassName, className, exceptionClass) {
        var element = document.querySelector(`${baseClassName} ${className}`);

        if (element) {
            document.addEventListener('click', function(event) {
                var parentElement = closest(event.target, className, true);

                if (!closest(event.target, exceptionClass)) {
                    toggleExpanded(element, parentElement);
                }
            });
        }
    }

    function copyElementsText(copyTextElement) {
        copyTextElement.select();
        document.execCommand('copy');
    }

    function addCopyEvent(parentClass, notificationMessage) {
        document.querySelector(parentClass).addEventListener('click', function() {
            copyElementsText(document.querySelector(`${parentClass} .eventpromote-url`));
            initNotification(notificationMessage);
        });
    }

    function initCopyUrlWidget() {
        addCopyEvent('.copy-ticketshop-link', gettext('copied_link_to_ticketshop'));
        addCopyEvent('.copy-all-events-link', gettext('copied_link_to_all_events'));
    }

    function initShareTicketshopUrlOnFacebookWidget() {
        var fbShareButtonEl = document.querySelector('._base-main .eventpromote-facebook');

        fbShareButtonEl.addEventListener('click', function() {
            window.open('https://www.facebook.com/sharer/sharer.php?u=' + _eventData.ticketshopUrl,
                'facebook-eventpromote-dialog',
                'width=600,height=400'
            );
        });
    }

    function initShareUrlWidget() {
        if (document.querySelector('.eventpromote-widget')) {
            initPopOverToggler('._base-main', '.eventpromote-widget', '.eventpromote-widget-content');
            initCopyUrlWidget();
            initShareTicketshopUrlOnFacebookWidget();
        }
    }

    function initGlobalMenu() {
        // Old menu:
        initPopOverToggler('._base-header', '.language-switch');
        initPopOverToggler('._base-header', '.user');

        /*
         * New menu:
         *
         * _.each(
         *     document.querySelectorAll('._base-header .global-menu .menu-item'),
         *     item => initGlobalMenuItem(item)
         * )
         *
         */
    }

    function initMainMenu() {
        var menuEl = document.querySelector('._base-sidebar-and-content .sidebar .menu');

        if (menuEl) {
            menuEl.addEventListener('click', function(event) {
                if (!closest(event.target, '.submenu-item', true)) {
                    var closestMenuItem = closest(event.target, '.menu-item', true);
                    if (closestMenuItem) {
                        closestMenuItem.classList.toggle('active');
                    }
                }
            });
        }
    }

    function initEventStatusSwitch() {
        if (!window._eventId) return;

        class PresaleSwitch extends React.Component {
            render() {
                return (
                    <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                        <span style={{ marginRight: 10 }}>{gettext('presale')}:</span>
                        <FlipSwitch
                            onChange={() => this.toggleEventStatus()}
                            on={_eventData.status === 'open' && !_eventData.is_sale_time_ended}
                        />
                    </div>
                );
            }

            toggleEventStatus() {

                if (_eventData.is_past) {
                    alert(gettext('presale_switch_event_is_past_message'));
                    return;
                }

                if (_eventData.is_sale_time_ended) {
                    if (confirm(gettext('presale_switch_presale_end_time_passed_message'))) {
                        window.location = '/dashboard/event/' + _eventId + '/general/settings/';
                    }
                    return;
                }

                const getConfirmText = () => {
                    if (_eventData.status === 'open') {
                        return gettext('confirm_close_sales');
                    } else {
                        return gettext('confirm_open_sales');
                    }
                };

                if (confirm(getConfirmText())) {

                    return new Promise((resolve, reject) => {
                        const getNewEventStatus = () => {
                            if (_eventData.status === 'open') {
                                return 'invisible';
                            } else {
                                return 'open';
                            }
                        };

                        const newEventStatus = getNewEventStatus();

                        this.props.event.set('status', newEventStatus);
                        this.props.event.update().then(() => {
                            _eventData.status = newEventStatus;
                            resolve();
                        });
                    });

                }

            }

        }

        ReactDOM.render(
            <PresaleSwitch event={new Event()} />,
            document.querySelector('._base-main-header .event-status-container')
        );
    }

    function initTooltips() {
        _.each(
            document.querySelectorAll('._tooltip'),
            tooltipEl => initTooltip(tooltipEl)
        );
    }

    function initPriceInputs() {
        _.each(
            document.querySelectorAll('._form-input-price'),
            priceInputEl => initPriceInput(priceInputEl)
        );

        function initPriceInput(priceInputEl) {
            priceInputEl.addEventListener('keyup', () => {
                priceInputEl.value = cleanPrice(priceInputEl.value);
            });

            priceInputEl.addEventListener('change', () => {
                priceInputEl.value = centsToPriceStr(priceStrToCents(priceInputEl.value));
            });
        }
    }

    function initDateTimePickers() {
        function getDateTimePickerEls() {
            return document.querySelectorAll('._datetime-picker');
        }

        _.each(getDateTimePickerEls(), function(dateTimePickerEl) {
            ReactDOM.render(
                <DateTimePicker
                    date={new Date(dateTimePickerEl.getAttribute('data-initial-datetime'))}
                    dateInputName={dateTimePickerEl.getAttribute('data-datetime-input-name')}
                    showTime={getShowTime()}
                    showTimeInputName={getShowTimeInputName()}
                />,
                dateTimePickerEl
            );

            function getShowTime() {
                if (dateTimePickerEl.hasAttribute('data-initial-show-time')) {
                    return parseInt(dateTimePickerEl.getAttribute('data-initial-show-time'));
                } else {
                    return true;
                }
            }

            function getShowTimeInputName() {
                if (dateTimePickerEl.hasAttribute('data-show-time-input-name')) {
                    return dateTimePickerEl.getAttribute('data-show-time-input-name');
                } else {
                    return false;
                }
            }
        });
    }

    function initNotification(notificationContent) {
        function createContainerEl() {
            const notificationContainerEl = document.createElement('div');
            notificationContainerEl.className = 'notification-container';
            document.body.appendChild(notificationContainerEl);
            return notificationContainerEl;
        }

        function getContainerEl() {
            const containerEl = document.querySelector('.notification-container');

            if (!containerEl) {
                return createContainerEl();
            }
            return containerEl;
        }

        ReactDOM.render(
            <Notification>
                {notificationContent}
            </Notification>,
            getContainerEl()
        );
    }

    function initMultiAddInput() {
        function getMultiAddInputEls() {
            return document.querySelectorAll('._form-multi-add-input');
        }

        _.each(getMultiAddInputEls(), function(multiAddInputEl) {
            ReactDOM.render(
                <MultiAddInputComponent
                    name={multiAddInputEl.getAttribute('data-input-name')}
                    inputType={multiAddInputEl.getAttribute('data-input-type')}
                />,
                multiAddInputEl
            );
        });
    }

    function initIframeResizer() {
        iFrameResize.iframeResizer(
            {
                messageCallback: function(callback) {
                    if (callback.message.action === 'event_created') {
                        window.location = '/dashboard/event/' + callback.message.event_id + '/general/info/';
                    }
                }
            },
            '._iframe-resizer'
        );
    }

    initEventSwitcher();
    initGlobalMenu();
    initMainMenu();
    initShareUrlWidget();
    initEventStatusSwitch();
    initTooltips();
    initPriceInputs();
    initDateTimePickers();
    initMultiAddInput();
    initIframeResizer();
})();
